import { captureException } from '@sentry/react'
import axios from 'axios'

type MailerLiteWebhookData = {
  email: string
}

export const mailerLiteWebhook = async (
  data: MailerLiteWebhookData,
): Promise<void> => {
  try {
    await axios.put(
      'https://hook.eu1.make.com/sd1u3aowb8dw5bi9f8y5pdjgiq5dobui',
      {
        ...data,
      },
    )
  } catch (error) {
    captureException(error, {
      extra: { data },
    })
  }
}
